import CpRules from './CpRules';

export default {
  __init__: ['CpRules'],
  CpRules: ['type', CpRules]
};
